import { useState, useEffect } from 'react'
import { ScrollProgress } from "./components/ScrollComponents"
import HeroSection from './components/TelegramBot/HeroSection'
import BenefitsSection from './components/TelegramBot/BenefitsSection'
import ServicesSection from './components/TelegramBot/ServicesSection'
import AutomationSection from './components/TelegramBot/AutomationSection'
import PackagesSection from './components/TelegramBot/PackagesSection'
import DemoSection from './components/TelegramBot/DemoSection'
import TechStackSection from './components/TelegramBot/TechStackSection'
import ProcessSection from './components/TelegramBot/ProcessSection'
import TelegramFAQSection from './components/TelegramBot/TelegramFAQSection'
import ContactSection from './components/TelegramBot/ContactSection'
import TelegramFooter from './components/TelegramBot/TelegramFooter'
import ContactModal from './components/TelegramBot/ContactModal'
import { FloatingActionButton } from "./components/ScrollComponents"
import CookieConsent from './components/CookieConsent'
import { initMetrikaOnStartup } from './utils/yandexMetrika'

function App() {
  // Initialize Yandex Metrika on startup (opt-out model)
  useEffect(() => {
    initMetrikaOnStartup()
  }, [])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [serviceType, setServiceType] = useState('ТГ бот - заявка')

  const openModal = () => {
    setServiceType('ТГ бот - заявка')
    setIsModalOpen(true)
  }
  
  const openConsultationModal = () => {
    setServiceType('ТГ бот - консультация')
    setIsModalOpen(true)
  }
  
  const openMVPModal = () => {
    setServiceType('ТГ бот - пакет MVP')
    setIsModalOpen(true)
  }
  
  const openStandardModal = () => {
    setServiceType('ТГ бот - пакет Стандарт')
    setIsModalOpen(true)
  }
  
  const openCorporateModal = () => {
    setServiceType('ТГ бот - пакет Корпоративный')
    setIsModalOpen(true)
  }
  
  const closeModal = () => setIsModalOpen(false)

  return (
    <div className="min-h-screen bg-white text-gray-900">
      <ScrollProgress />
      <HeroSection onCTAClick={openModal} />
      <BenefitsSection />
      <ServicesSection />
      <AutomationSection />
      <PackagesSection 
        onMVPClick={openMVPModal}
        onStandardClick={openStandardModal}
        onCorporateClick={openCorporateModal}
      />
      <DemoSection />
      <TechStackSection />
      <ProcessSection />
      <TelegramFAQSection />
      <ContactSection onCTAClick={openConsultationModal} />
      <TelegramFooter onCTAClick={openModal} />
      <ContactModal isOpen={isModalOpen} onClose={closeModal} serviceType={serviceType} />
      <FloatingActionButton />
      <CookieConsent />
    </div>
  )
}

export default App
